// extracted by mini-css-extract-plugin
export default {"summary":"mealsSummary_summary__zH2dm"};